<template>
  <v-container>
    <v-row>
      <v-col>
        <div>
          <p v-if="isSelfSurvey" class="display-1 primary--text">
            We value your feedback.
          </p>
          <p v-else class="display-1 primary--text">
            We value your feedback on your interactions with
            {{ params.EvaluateeFullName }}.
          </p>
        </div>

        <div>
          <p v-if="isSelfSurvey" class="font-weight-light">
            As part of the {{ params.CurrentYear }} Partner APE process, you are asked to provide feedback about
            <span class="primary--text">yourself</span> in relation to the following Partner behaviors:
          </p>
          <p v-else class="font-weight-light">
            As part of the {{ params.CurrentYear }} Partner APE process, please provide feedback on
            <span class="primary--text">{{ params.EvaluateeFullName }}</span>
            in relation to the following Partner behaviors:
          </p>
        </div>

        <div>
          <p v-for="(field, index) in displayBehaviourFields" :key="index">
            <span v-if="behaviours[field].title" class="font-weight-black">
              {{ behaviours[field].title + " " }}
            </span>
            <span v-if="behaviours[field].subtitle">{{ behaviours[field].subtitle(true) }}</span>
          </p>
        </div>

        <template v-if="isSelfSurvey">
          <div>
            <p class="font-weight-light">
              The self-assessment should take approximately 10 minutes to complete, and you will be able to review your
              responses before submitting (please do not use the back button on your browser as you progress with the
              survey).
            </p>
          </div>

          <div>
            <p class="font-weight-light">
              Once you've completed your self-assessment you will be asked to nominate at least 5 peers to provide
              feedback on you.
            </p>
          </div>
        </template>

        <template v-else>
          <div>
            <p class="font-weight-light">
              At the end of the survey you will have the opportunity to provide other general feedback on
              <span class="primary--text">{{ params.EvaluateeFullName }}</span>
              as an additional input into the APE process.
            </p>
          </div>

          <div>
            <p class="font-weight-light">
              The survey should take approximately 10 minutes to complete, and you will be able to review your responses
              before submitting (please do not use the back button on your browser as you progress with the survey).
            </p>
          </div>

          <div>
            <p class="font-weight-light">
              Your feedback will be submitted anonymously, aggregated with at least two others, and provided to the
              feedback receiver and their MBO-setter.
            </p>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { BehaviourField } from '@/configuration/BehaviourField';

export default {
  name: 'Intro',

  data() {
    return {
      displayBehaviourFields: [
        BehaviourField.Bhv_Generosity,
        BehaviourField.Bhv_Passion,
        BehaviourField.Bhv_Solidarity,
        BehaviourField.Bhv_Curiosity,
        BehaviourField.Bhv_Boldness,
      ],
    };
  },
  computed: {
    ...mapGetters(['currentStep', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
    behaviours() {
      return this.$store.state.behaviours;
    },
  },
};
</script>
